import { SectionToolbar } from "../components/ui";
import { Dlc05Badge } from "./labels";
import { PersonalTasksCard } from "./PersonalTasksCard";
import { GlobalTodoTab } from "./TodoView";

/** „Moje TODO" — zakładka strony „Kontrola procesu" (/power-projects/kontrola?tab=todo)
 * z tabelą pozycji ze WSZYSTKICH projektów ZE danej osoby (łącznie). Zakres wyznacza backend: dyr. techniczny / CEO widzi wszystkie projekty
 * i może filtrować po osobie; zwykły prowadzący widzi tylko własne tematy. Dostęp gatuje
 * DLCModuleGuard (DLC_01) + CanAccessZEAdvisor po stronie API. */
export function MyTodoSection() {
  return (
    <div className="space-y-4">
      <SectionToolbar
        text={
          <>
            Wszystkie Twoje projekty ZE łącznie — pozycje od najpilniejszej. Zablokowane kroki
            (czekające na poprzedników w procesie) są oznaczone i nie liczą się jako „nasz ruch”.
            Na górze własne zadania spoza projektów.
            <Dlc05Badge />
          </>
        }
      />
      <PersonalTasksCard />
      <GlobalTodoTab defaultMine />
    </div>
  );
}
